import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
export const ProjectSpacesRearrangeModalContext = /*#__PURE__*/ createContext(null);
// TODO: move away from context based approach and use routing to manage state of whether the modal is open or not
export const useProjectSpacesRearrangeModalContext = ()=>{
    const context = useContext(ProjectSpacesRearrangeModalContext);
    if (!context) {
        throw new Error('This must be used within a <SpaceContainer> component or wrap it with ProjectSpacesRearrangeModalContext.Provider.');
    }
    return context;
};
export const ProjectSpacesRearrangeModalContextProvider = ({ children })=>{
    const [isRearrangeModalVisible, setIsRearrangeModalVisible] = useState(false);
    return /*#__PURE__*/ _jsx(ProjectSpacesRearrangeModalContext.Provider, {
        value: {
            isRearrangeModalVisible,
            setIsRearrangeModalVisible
        },
        children: children
    });
};
